import { call, put, select } from 'redux-saga/effects';
import { push } from 'connected-react-router';

import * as pageStateService from '../page-state/page-state.saga-services';
import * as pageInitializerService from '../page.initializer.saga-service';
import * as companyContextsResourceService from '../../resource/company-contexts/company-contexts.saga-service';
import * as companyToolsCategoryResourceService from '../../resource/company-tools-category/company-tools-category.saga-service';
import * as companyToolsCategoryActions from '../../resource/company-tools-category/company-tools-category.actions';
import * as types from './company-context.types';
import { companyToolsCategorySelectors } from '../../resource/company-tools-category/company-tools-category.selectors';
import { ICompanyToolsCategory } from '../../resource/company-tools-category/company-tools-category.types';
import { ICompanyContext } from '../../resource/company-contexts/company-contexts.types';

export function* initialCompanyContextPage() {
  yield call(pageStateService.initPage, 'companyContext');
  yield call(pageInitializerService.initPage);
  yield call(companyToolsCategoryResourceService.searchCompanyToolsCategories);
  yield call(pageStateService.completedInit, 'companyContext');
}

export function* createCompanyContext(action: types.ICreateCompanyContext) {
  const companyContext = (yield call(
    companyContextsResourceService.createCompanyContext,
    action.payload.companyToolsCategoryId,
  )) as ICompanyContext | undefined;

  if (!companyContext) {
    return;
  }

  const companyToolsCategory = (yield select(
    companyToolsCategorySelectors.selectResourceById,
    companyContext.companyToolsCategoryId,
  )) as ICompanyToolsCategory | undefined;

  if (companyToolsCategory) {
    yield put(
      companyToolsCategoryActions.storeCompanyToolsCategory({
        ...companyToolsCategory,
        companyContextIds: [...companyToolsCategory.companyContextIds, companyContext.id],
      }),
    );
  }

  yield put(push(`/agency-tools/context/${companyContext.id}/edit`));
}

export function* updateCompanyContext(action: types.IUpdateCompanyContext) {
  yield call(companyContextsResourceService.updateCompanyContext, action.payload.id, action.payload.data);
}

export function* deleteCompanyContext(action: types.IDeleteCompanyContext) {
  yield call(companyContextsResourceService.deleteCompanyContext, action.payload);
}
